import { PillCell } from "../../Utils/DataTable/Cells";

const columnCellMap = {
  status: PillCell,
  support_admin_status: PillCell
}

export default columnCellMap;